export default {"src":"/_next/static/media/33.9a3a834d.svg","height":25,"width":25};